import { replaceTemplate } from '@monoimin/intl';

import { prepareRealEstateTitle } from '@monoimin/utils/formatters';

import { ProgramDetailsData } from '../components/ProgramDetails';

import { declineCountry } from './declineCountry';

import type { Locales } from '@monoimin/sb-types';

const getFormattedStatus = (
  programDetails: ProgramDetailsData | null,
  locale: Locales
) => {
  const status = programDetails?.status;
  if (!status) {
    return '';
  }

  if (locale === 'en') {
    return `and ${status.toLowerCase()}`;
  }

  if (locale === 'ru') {
    if (status === 'ВНЖ') {
      return 'и ВНЖ';
    }

    if (status === 'Гражданство') {
      return 'и гражданству';
    }

    if (status === 'ПМЖ') {
      return 'и ПМЖ';
    }
  }

  return '';
};

/**
 * Меняем данные (описание эксперта) для блока с экспертом на страницах недвижимости
 *
 * @param countryCode - Код страны.
 * @param locale - Текущая локаль.
 * @returns Возвращает описание эксерта со страной.
 */
export const createExpertDescription = async (
  countryCode: string,
  locale: Locales,
  programDetails: ProgramDetailsData | null
) => {
  const formattedCountryName = await declineCountry(countryCode, 'Р', locale);

  const formattedStatus = getFormattedStatus(programDetails, locale);

  if (formattedCountryName) {
    const titles = {
      en: 'Expert on real estate {status} by investment in {country}',
      ru: `Эксперт по недвижимости {status} {country} за инвестиции`,
      de: 'Experte für Immobilien {status} durch Investitionen in {country}',
      tr: "{country}'deki yatırımlarla {status} gayrimenkul uzmanı",
      es: 'Experto en {country} {status} por inversión inmobiliaria',
    };
    return prepareRealEstateTitle(
      replaceTemplate(titles[locale], {
        country: formattedCountryName,
        status: formattedStatus,
      })
    );
  }

  return '';
};

export default createExpertDescription;
